import axios from "axios";

// const request = async (metodo, url, data = null) => {
const request = async (
  metodo,
  url,
  data = null,
  extraConfig = {},
  apiExterna = false
) => {
  console.log(metodo, url);
  try {
    let urlfinal = `${process.env.REACT_APP_API_EXTERNA_URL}${url}`;
    // if (apiExterna) {
    //   urlfinal = `${process.env.REACT_APP_API_EXTERNA_URL}${url}`;
    // } else {
    //   urlfinal = `${process.env.REACT_APP_API_URL}${url}`;
    // }
    const response = await axios({
      method: metodo,
      url: urlfinal,
      data,
      headers: {
        Authorization: `Bearer ${localStorage.getItem(
          process.env.REACT_APP_PREFIJO + "token"
        )}`,
        "X-App-Origen": "reto", // 👈 cabecera personalizada
      },

      validateStatus: (status) => status < 400, // ANTES HABIA 500 422 tambien es un error
      ...extraConfig,
    });

    if (response.status === 401) {
      console.log("Token existe pero no es válido");
      localStorage.removeItem(process.env.REACT_APP_PREFIJO + "token");
      window.location.href = "/login";
      return {
        peticion: response.data,
        error: true,
        status: 401,
        mensaje: response.data?.message,
      };
    }

    return { peticion: response.data, error: false };
  } catch (err) {
    const status = err.response?.status || null;
    if (status === 401) {
      console.log("Token existe pero no es válido");
      localStorage.removeItem(process.env.REACT_APP_PREFIJO + "token");
      window.location.href = "/login";
    } else {
      console.error("Error en petición:", err.message);
    }
    return {
      peticion: err.response?.data,
      error: true,
      status,
      mensaje: err.response?.data?.message || err.message,
    };
  }
};

export const peticionGet = (url) => request("get", url);
export const peticionPost = (url, data) => request("post", url, data);
export const peticionPut = (url, data) => request("put", url, data);
export const peticionDelete = (url) => request("delete", url);
export const peticionGetBlob = (url) =>
  request("get", url, null, { responseType: "blob" }); // añadido para blobs
